/* tslint:disable:max-line-length */
import * as React from 'react';
import pure from 'recompose/pure';

class MenuIcon extends React.Component<{ style: any }> {
  render() {
    return (
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="currentcolor"
        {...this.props}
      >
        <path fillRule="evenodd" clipRule="evenodd" d="M1 5C1 3.89543 1.89543 3 3 3H21C22.1046 3 23 3.89543 23 5C23 6.10457 22.1046 7 21 7H3C1.89543 7 1 6.10457 1 5ZM1 12C1 10.8954 1.89543 10 3 10H21C22.1046 10 23 10.8954 23 12C23 13.1046 22.1046 14 21 14H3C1.89543 14 1 13.1046 1 12ZM3 17C1.89543 17 1 17.8954 1 19C1 20.1046 1.89543 21 3 21H21C22.1046 21 23 20.1046 23 19C23 17.8954 22.1046 17 21 17H3Z" />
      </svg>
    );
  }
}

const Icon = pure(MenuIcon);
Icon.displayName = 'MenuIcon';
export default Icon;
